import React, { useEffect, useState, lazy } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { CTAButton } from '../components/CTAButton';
import { CheckIcon, ChevronRightIcon, ShieldIcon, StarIcon, TruckIcon } from 'lucide-react';
import { MetaPixel, trackInitiateCheckout } from '../components/MetaPixel';
export const ProductDetail = () => {
  const location = useLocation();
  const [isSticky, setIsSticky] = useState(false);
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const getCheckoutLink = () => {
    return `/checkout${location.search}`;
  };
  return <div className="flex flex-col min-h-screen bg-white" id="top" data-id="element-236">
      <MetaPixel data-id="element-237" />
      <Header data-id="element-238" />
      <main className="flex-grow" data-id="element-239">
        {/* Hero Section */}
        <div className="bg-[#F0FDFA] py-12" data-id="element-240">
          <div className="container mx-auto px-4" data-id="element-241">
            <div className="md:flex md:items-center md:space-x-8" data-id="element-242">
              <div className="md:w-1/2 mb-8 md:mb-0" data-id="element-243">
                <Link to="/adv" className="text-[#0D9488] text-sm hover:underline mb-4 inline-block" data-id="element-244">
                  &larr; Back to Article
                </Link>
                <h1 className="text-3xl md:text-4xl font-bold mb-3" data-id="element-245">
                  Wake Up to Healthier, Clearer Nails
                </h1>
                <h2 className="text-xl md:text-2xl text-[#0D9488] font-medium mb-4" data-id="element-246">
                  Kills toenail fungus at the source while you sleep
                </h2>
                <div className="flex items-center mb-4" data-id="element-247">
                  <div className="flex" data-id="element-248">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} className="text-yellow-400 fill-current" data-id="element-249" />)}
                  </div>
                  <span className="ml-2 text-sm text-gray-600" data-id="element-250">
                    4.9 (3,278 reviews)
                  </span>
                </div>
                <p className="text-gray-700 mb-6" data-id="element-251">
                  ClearNail's patented transdermal patches work overnight to
                  deliver powerful antifungal compounds directly to the
                  infection site. Our unique formula penetrates the nail to
                  eliminate fungus at its source, so you can wake up each day
                  one step closer to healthier, clearer nails.
                </p>
                <div className="hidden md:block" data-id="element-252">
                  <Link to={getCheckoutLink()} className="inline-flex items-center justify-center bg-[#0F766E] text-white font-medium py-3 px-6 rounded-lg hover:bg-teal-800 transition-colors" data-id="element-253">
                    Choose Your Bundle
                    <ChevronRightIcon size={18} className="ml-2" data-id="element-254" />
                  </Link>
                </div>
              </div>
              <div className="md:w-1/2" data-id="element-255">
                <div className="bg-white rounded-lg overflow-hidden shadow-md" data-id="element-256">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bMDhyJEehiSsDMZZAdCFds/ezgif.com-video-to-webp-converter_4.webp" alt="Toenail with fungal infection that ClearNail treats" className="w-full h-auto object-cover" loading="eager" width="600" height="400" fetchpriority="high" data-id="element-257" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Benefits Section */}
        <div className="container mx-auto px-4 py-12" data-id="element-258">
          <div className="mb-8 text-center" data-id="element-259">
            <h3 className="text-lg font-semibold text-[#0D9488] mb-2" data-id="element-260">
              Why ClearNail Works
            </h3>
            <p className="text-gray-700 max-w-2xl mx-auto" data-id="element-261">
              Our patented transdermal technology delivers powerful antifungal
              compounds directly where they're needed most.
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-262">
            <div className="bg-white p-6 rounded-lg shadow-sm text-center" data-id="element-263">
              <div className="bg-teal-50 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-264">
                <span className="text-[#0D9488] font-bold" data-id="element-265">1</span>
              </div>
              <h4 className="font-bold mb-2" data-id="element-266">Penetrates the Nail</h4>
              <p className="text-gray-600 text-sm" data-id="element-267">
                Micro-needle technology creates channels for active ingredients
                to reach the infection source
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm text-center" data-id="element-268">
              <div className="bg-teal-50 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-269">
                <span className="text-[#0D9488] font-bold" data-id="element-270">2</span>
              </div>
              <h4 className="font-bold mb-2" data-id="element-271">Eliminates Fungus</h4>
              <p className="text-gray-600 text-sm" data-id="element-272">
                Powerful botanical antifungals attack and destroy the fungal
                infection at its source
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm text-center" data-id="element-273">
              <div className="bg-teal-50 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-274">
                <span className="text-[#0D9488] font-bold" data-id="element-275">3</span>
              </div>
              <h4 className="font-bold mb-2" data-id="element-276">Restores Healthy Nails</h4>
              <p className="text-gray-600 text-sm" data-id="element-277">
                Nourishing compounds promote the growth of new, healthy nail
                tissue
              </p>
            </div>
          </div>
          {/* Added How to Use section with image */}
          <div className="my-12" data-id="element-278">
            <h3 className="text-xl font-bold text-center mb-6" data-id="element-279">
              How to Use ClearNail
            </h3>
            <div className="md:flex md:items-center md:space-x-8" data-id="element-280">
              <div className="md:w-1/2 mb-6 md:mb-0" data-id="element-281">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pxpRpL5y2jQF8DFPyW9zPR/Google_AI_Studio_2025-08-28T15_31_37.543Z.png" alt="Close-up of hands applying a transparent ClearNail patch to a toe" className="w-full rounded-lg shadow-md" loading="lazy" width="600" height="400" data-id="element-282" />
              </div>
              <div className="md:w-1/2" data-id="element-283">
                <ol className="space-y-4" data-id="element-284">
                  <li className="flex" data-id="element-285">
                    <div className="bg-[#0F766E] text-white rounded-full w-6 h-6 flex items-center justify-center font-bold flex-shrink-0 mr-3 mt-0.5" data-id="element-286">
                      1
                    </div>
                    <div data-id="element-287">
                      <h4 className="font-bold" data-id="element-288">
                        Clean and dry your affected nail
                      </h4>
                      <p className="text-gray-600" data-id="element-289">
                        Ensure the nail is completely dry before application.
                      </p>
                    </div>
                  </li>
                  <li className="flex" data-id="element-290">
                    <div className="bg-[#0F766E] text-white rounded-full w-6 h-6 flex items-center justify-center font-bold flex-shrink-0 mr-3 mt-0.5" data-id="element-291">
                      2
                    </div>
                    <div data-id="element-292">
                      <h4 className="font-bold" data-id="element-293">
                        Remove the patch from its packaging
                      </h4>
                      <p className="text-gray-600" data-id="element-294">
                        Peel back the protective film to expose the adhesive
                        side.
                      </p>
                    </div>
                  </li>
                  <li className="flex" data-id="element-295">
                    <div className="bg-[#0F766E] text-white rounded-full w-6 h-6 flex items-center justify-center font-bold flex-shrink-0 mr-3 mt-0.5" data-id="element-296">
                      3
                    </div>
                    <div data-id="element-297">
                      <h4 className="font-bold" data-id="element-298">
                        Apply patch directly to the affected nail
                      </h4>
                      <p className="text-gray-600" data-id="element-299">
                        Press firmly to ensure complete contact with the nail
                        surface.
                      </p>
                    </div>
                  </li>
                  <li className="flex" data-id="element-300">
                    <div className="bg-[#0F766E] text-white rounded-full w-6 h-6 flex items-center justify-center font-bold flex-shrink-0 mr-3 mt-0.5" data-id="element-301">
                      4
                    </div>
                    <div data-id="element-302">
                      <h4 className="font-bold" data-id="element-303">
                        Leave on overnight (6-8 hours)
                      </h4>
                      <p className="text-gray-600" data-id="element-304">
                        Remove in the morning and discard. Use a fresh patch
                        each night.
                      </p>
                    </div>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        {/* Pricing Section */}
        <div className="bg-gray-50 py-12" id="pricing" data-id="element-305">
          <div className="container mx-auto px-4" data-id="element-306">
            <h2 className="text-2xl md:text-3xl font-bold text-center mb-8" data-id="element-307">
              Choose Your Bundle
            </h2>
            <div className="grid md:grid-cols-3 gap-6" data-id="element-308">
              {/* Starter Bundle */}
              <div className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-309">
                <div className="p-6" data-id="element-310">
                  <h3 className="text-xl font-bold mb-2" data-id="element-311">Starter</h3>
                  <p className="text-gray-600 mb-4" data-id="element-312">
                    For light to moderate cases
                  </p>
                  <div className="mb-4" data-id="element-313">
                    <span className="text-3xl font-bold text-[#0D9488]" data-id="element-314">
                      24,90 €
                    </span>
                  </div>
                  <p className="text-gray-700 mb-6" data-id="element-315">
                    <strong data-id="element-316">1 Box</strong> (14 patches)
                    <br data-id="element-317" />
                    2-week treatment course
                  </p>
                  <ul className="space-y-2 mb-6" data-id="element-318">
                    {['Treats single nail infections', 'Ideal for early-stage fungus', 'Visible improvement in 2 weeks'].map((feature, index) => <li key={index} className="flex items-start" data-id="element-319">
                        <CheckIcon size={16} className="text-green-500 mr-2 flex-shrink-0 mt-1" data-id="element-320" />
                        <span className="text-sm" data-id="element-321">{feature}</span>
                      </li>)}
                  </ul>
                  <Link to={getCheckoutLink()} className="inline-flex items-center justify-center bg-[#0F766E] text-white font-medium py-3 px-6 rounded-lg hover:bg-teal-800 transition-colors w-full" data-id="element-322">
                    Get Starter Bundle
                    <ChevronRightIcon size={18} className="ml-2" data-id="element-323" />
                  </Link>
                </div>
              </div>
              {/* Standard Bundle */}
              <div className="bg-white rounded-lg shadow-lg overflow-hidden border-2 border-teal-500 transform md:scale-105" data-id="element-324">
                <div className="bg-teal-500 py-2 text-center" data-id="element-325">
                  <span className="text-white text-sm font-medium" data-id="element-326">
                    MOST POPULAR
                  </span>
                </div>
                <div className="p-6" data-id="element-327">
                  <h3 className="text-xl font-bold mb-2" data-id="element-328">Standard</h3>
                  <p className="text-gray-600 mb-4" data-id="element-329">Recommended full course</p>
                  <div className="mb-4" data-id="element-330">
                    <span className="text-3xl font-bold text-[#0D9488]" data-id="element-331">
                      39,90 €
                    </span>
                    <span className="ml-2 text-gray-500 line-through" data-id="element-332">
                      49,80 €
                    </span>
                  </div>
                  <p className="text-gray-700 mb-6" data-id="element-333">
                    <strong data-id="element-334">2 Boxes</strong> (28 patches)
                    <br data-id="element-335" />
                    Complete 4-week treatment
                  </p>
                  <ul className="space-y-2 mb-6" data-id="element-336">
                    {['Treats multiple nail infections', 'Complete elimination of fungus', 'Prevents fungus recurrence', 'Save 20% compared to single box'].map((feature, index) => <li key={index} className="flex items-start" data-id="element-337">
                        <CheckIcon size={16} className="text-green-500 mr-2 flex-shrink-0 mt-1" data-id="element-338" />
                        <span className="text-sm" data-id="element-339">{feature}</span>
                      </li>)}
                  </ul>
                  <Link to={getCheckoutLink()} className="inline-flex items-center justify-center bg-[#0F766E] text-white font-medium py-3 px-6 rounded-lg hover:bg-teal-800 transition-colors w-full" data-id="element-340">
                    Get Standard Bundle
                    <ChevronRightIcon size={18} className="ml-2" data-id="element-341" />
                  </Link>
                </div>
              </div>
              {/* Complete Bundle */}
              <div className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-342">
                <div className="p-6" data-id="element-343">
                  <h3 className="text-xl font-bold mb-2" data-id="element-344">Complete</h3>
                  <p className="text-gray-600 mb-4" data-id="element-345">
                    Best value for persistent cases
                  </p>
                  <div className="mb-4" data-id="element-346">
                    <span className="text-3xl font-bold text-[#0D9488]" data-id="element-347">
                      49,90 €
                    </span>
                    <span className="ml-2 text-gray-500 line-through" data-id="element-348">
                      74,70 €
                    </span>
                  </div>
                  <p className="text-gray-700 mb-6" data-id="element-349">
                    <strong data-id="element-350">3 Boxes</strong> (42 patches)
                    <br data-id="element-351" />
                    Extended 6-week treatment
                  </p>
                  <ul className="space-y-2 mb-6" data-id="element-352">
                    {['For severe or persistent infections', 'Complete nail restoration', 'Extended protection period', 'Save 33% compared to single boxes'].map((feature, index) => <li key={index} className="flex items-start" data-id="element-353">
                        <CheckIcon size={16} className="text-green-500 mr-2 flex-shrink-0 mt-1" data-id="element-354" />
                        <span className="text-sm" data-id="element-355">{feature}</span>
                      </li>)}
                  </ul>
                  <Link to={getCheckoutLink()} className="inline-flex items-center justify-center bg-[#0F766E] text-white font-medium py-3 px-6 rounded-lg hover:bg-teal-800 transition-colors w-full" data-id="element-356">
                    Get Complete Bundle
                    <ChevronRightIcon size={18} className="ml-2" data-id="element-357" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="flex flex-col space-y-3 text-sm text-gray-600 max-w-md mx-auto mt-8 text-center" data-id="element-358">
              <div className="flex items-center justify-center" data-id="element-359">
                <TruckIcon size={16} className="mr-2" data-id="element-360" />
                <span data-id="element-361">Free shipping on all orders</span>
              </div>
              <div className="flex items-center justify-center" data-id="element-362">
                <ShieldIcon size={16} className="mr-2" data-id="element-363" />
                <span data-id="element-364">30-day satisfaction guarantee</span>
              </div>
            </div>
          </div>
        </div>

        {/* Testimonials Section */}
        <div className="container mx-auto px-4 py-12" data-id="element-365">
          <h2 className="text-2xl font-bold text-center mb-8" data-id="element-366">
            What Our Customers Say
          </h2>
          {/* Added image of woman enjoying coffee */}
          <div className="mb-8" data-id="element-367">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tTgYz4xA4XFYhLR8ed9gKM/Google_AI_Studio_2025-08-28T15_32_02.603Z.png" alt="Happy customer enjoying coffee at a cafe with a confident smile after using ClearNail" className="w-full h-64 object-cover rounded-lg shadow-md mb-6" loading="lazy" width="800" height="400" data-id="element-368" />
            <p className="text-center text-gray-700 italic max-w-2xl mx-auto" data-id="element-369">
              "Now I can enjoy my favorite activities without worrying about
              hiding my feet. ClearNail gave me back my confidence!"
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-6" data-id="element-370">
            {[{
            name: 'Michael T.',
            review: 'After trying countless treatments over 15 years, ClearNail finally gave me results. My nails are clear for the first time in over a decade!'
          }, {
            name: 'Sarah K.',
            review: "I was too embarrassed to wear sandals for years. After 4 weeks with ClearNail, I'm showing off my feet again. The transformation is incredible."
          }, {
            name: 'David R.',
            review: 'As a diabetic, I was worried about my nail fungus. My doctor recommended ClearNail, and it worked without any side effects. Highly recommend!'
          }].map((testimonial, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-sm" data-id="element-371">
                <div className="flex items-center mb-3" data-id="element-372">
                  <div className="flex" data-id="element-373">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} className="text-yellow-400 fill-current" data-id="element-374" />)}
                  </div>
                  <span className="ml-2 text-sm font-medium" data-id="element-375">
                    Verified Purchase
                  </span>
                </div>
                <p className="italic mb-4" data-id="element-376">"{testimonial.review}"</p>
                <p className="text-sm font-medium" data-id="element-377">- {testimonial.name}</p>
              </div>)}
          </div>
        </div>
      </main>
      <Footer data-id="element-378" />
      {/* Sticky CTA */}
      <div className={`fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-gray-200 p-3 transition-transform duration-300 ${isSticky ? 'translate-y-0' : 'translate-y-full'} md:hidden`} data-id="element-379">
        <div className="container mx-auto" data-id="element-380">
          <Link to={getCheckoutLink()} className="flex items-center justify-center bg-[#0F766E] text-white font-medium py-3 px-6 rounded-lg hover:bg-teal-800 transition-colors w-full" onClick={trackInitiateCheckout} data-id="element-381">
            Choose Your Bundle
            <ChevronRightIcon size={18} className="ml-1" data-id="element-382" />
          </Link>
        </div>
      </div>
    </div>;
};